import classNames from 'classnames';
import React from 'react';

import { BiannualAppointmentStatus } from '@vestahealthcare/common/enums';
import { translate } from '@vestahealthcare/common/i18n';
import {
  PodReportingDataExtended,
  PodReportingVisit,
} from '@vestahealthcare/common/models';

import { PodReportingProgramTable } from './PodReportingProgramTable';
import { PodReportingStyles } from './PodReportingStyles';

type Props = {
  data?: PodReportingVisit;

  onClickBiannual: (
    item: PodReportingDataExtended,
    parentItem?: PodReportingDataExtended,
  ) => ((item: PodReportingDataExtended) => void) | undefined;
  onClickEstablishedVisit: (
    item: PodReportingDataExtended,
    parentItem?: PodReportingDataExtended,
  ) => ((item: PodReportingDataExtended) => void) | undefined;
};

export const PodReportingVisitSummaryPage = ({
  data,
  onClickBiannual,
  onClickEstablishedVisit,
}: Props) => {
  const styles = PodReportingStyles();

  if (!data) return <></>;

  const { biannual, established } = data;

  const getRowTooltip = (item: PodReportingDataExtended) => {
    if (
      [
        BiannualAppointmentStatus.COMPLETED.toString(),
        BiannualAppointmentStatus.NOT_YET_SCHEDULED.toString(),
        BiannualAppointmentStatus.PENDING.toString(),
        BiannualAppointmentStatus.RESCHEDULE_FUTURE_MONTH.toString(),
        BiannualAppointmentStatus.RESCHEDULE_NEEDED.toString(),
      ].includes(item.name)
    ) {
      return translate(`podReporting.table.visitTooltip.${item.id}`);
    }
  };

  return (
    <div className={classNames('grid-wrapper', styles.borderContainer)}>
      {biannual && (
        <div className="grid-span-6">
          <div className="flex spaced wrap">
            <div className="flex gap">
              <h2 className={styles.subtitle}>
                {translate('podReporting.titleVisit')}
              </h2>
            </div>
          </div>
          <PodReportingProgramTable
            data={biannual}
            header={translate('podReporting.table.biannual')}
            getRowOnClick={onClickBiannual}
            getRowTooltip={getRowTooltip}
          />
        </div>
      )}
      {established && (
        <div className="grid-span-6">
          <div className="flex spaced wrap">
            <div className="flex gap">
              <h2 className={styles.subtitle}>
                {translate('podReporting.titleEstablishedVisit')}
              </h2>
            </div>
          </div>
          <PodReportingProgramTable
            data={established}
            header={translate('podReporting.table.visit')}
            getRowOnClick={onClickEstablishedVisit}
            getRowTooltip={getRowTooltip}
          />
        </div>
      )}
    </div>
  );
};
